import { CreateScheduleDtoV2 } from '@mi-front/core';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';
import { LDate } from '../../../../../../components/date/LDate';
import { LTime } from '../../../../../../components/date/LTime';

export const CreateSchedulesPreview = ({ data }: { data: CreateScheduleDtoV2[] }) => {
  const { $t } = useIntl();
  return (
    <TableContainer component={Paper} sx={{ mt: 3 }}>
      <Table
        size="small"
        sx={{ minWidth: 650 }}
        aria-label={$t({
          id: 'common.simpleTableAriaLabel',
          defaultMessage: 'Data table',
        })}
      >
        <TableHead>
          <TableRow>
            <TableCell>#</TableCell>
            <TableCell>
              <FormattedMessage id="audit.schedulesPreview.dateTime" defaultMessage="Fecha/hora" />
            </TableCell>
            <TableCell>
              <FormattedMessage id="audit.filesUpload.materialId" defaultMessage="ID material" />
            </TableCell>
            <TableCell>
              <FormattedMessage
                id="audit.schedulesPreview.advertiser"
                defaultMessage="Advertiser"
              />
            </TableCell>
            <TableCell>
              <FormattedMessage id="audit.schedulesPreview.campaign" defaultMessage="Campaña" />
            </TableCell>
            <TableCell>
              <FormattedMessage id="audit.schedulesPreview.version" defaultMessage="Version" />
            </TableCell>
            <TableCell align="center">
              <FormattedMessage id="audit.schedulesPreview.tolerance" defaultMessage="Tolerancia" />
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((s, index) => (
            <TableRow key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
              <TableCell>{index + 1}</TableCell>
              <TableCell component="th" scope="row">
                <div style={{ display: 'flex', gap: '0.5rem' }}>
                  <LDate value={s.datetime} day="2-digit" month="2-digit" year="2-digit" />
                  <LTime value={s.datetime} />
                </div>
              </TableCell>
              <TableCell>{s.customId}</TableCell>
              <TableCell>{s.advertiser}</TableCell>
              <TableCell>{s.campaign}</TableCell>
              <TableCell>{s.version}</TableCell>
              <TableCell align="center">
                {Math.round(s.toleranceBefore || 0)} / {Math.round(s.tolerance || 0)}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
